import React from 'react'

function FilterStatus({ onSelectStatus }) {

  const filterHandler = (event) => {
    onSelectStatus(event.target.value);
  };

  return (
    <>
      <select
        onChange={filterHandler}
        className="form-control w-auto"
      >
        <option value="">Tất cả</option>
        <option value="success">Thành công</option>
        <option value="fail">Không thành công</option>
      </select>
    </>
  )
}

export default FilterStatus
